import { render, staticRenderFns } from "./StatusComp.vue?vue&type=template&id=720032d0&scoped=true&"
import script from "./StatusComp.vue?vue&type=script&lang=js&"
export * from "./StatusComp.vue?vue&type=script&lang=js&"
import style0 from "./StatusComp.vue?vue&type=style&index=0&id=720032d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720032d0",
  null
  
)

export default component.exports